import { observer } from 'mobx-react-lite'
import { CalendarDropdown } from 'shared/ui'
import { useChatbotAnalyticContext } from 'pages/chatbot/pages/chatbotAnalytic/context/chatbotAnalyticContext'
import styles from './styles.module.scss'

export const ChatbotAnalyticCalendar = observer(() => {
  const { list } = useChatbotAnalyticContext()
  const { calendarFilterStore } = list

  return (
    <div className={styles.calendar}>
      <CalendarDropdown store={calendarFilterStore} />
    </div>
  )
})
